import {getInterpreterStatus} from "../../api/premission";

const state = {
    isInterpreter: false,
    selfInfo: {fullname:"", current_state:""}
}

const mutations = {
    SET_INTERPRETER: (state, value)=>{
        state.isInterpreter = value
    },
    SET_INFO:(state, value)=>{
        state.selfInfo = {fullname:value.fullname, current_state:value.current_state}
    }
}

const actions = {
    getIsInterpreter({commit}){
        return new Promise((resolve => {
            getInterpreterStatus()
                .then(res=>{
                    resolve({status:true})
                    commit("SET_INTERPRETER", "yes")
                })
                .catch(error=>{
                    resolve({status:false})
                    commit("SET_INTERPRETER", "no")
                })
        }))
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}